/** Max past skew for client-supplied ticket document `createdAt` (ms). */
export const TICKET_CREATED_AT_MAX_PAST_MS = 24 * 60 * 60 * 1000;
/** Max future skew for wall-clock-encoded `createdAt` (covers devices ahead of server UTC). */
export const TICKET_CREATED_AT_MAX_FUTURE_MS = 14 * 60 * 60 * 1000;
/**
 * Validates optional ticket document `createdAt` captured as wall-clock components
 * encoded in UTC slots (e.g. device 11:36 → `2026-05-15T11:36:00.000Z`).
 * Compares component timelines, not geographic instants vs server clock.
 */
export function isWallClockDocumentCreatedAtInRange(createdAt, now = new Date()) {
    const clientMs = Date.UTC(createdAt.getUTCFullYear(), createdAt.getUTCMonth(), createdAt.getUTCDate(), createdAt.getUTCHours(), createdAt.getUTCMinutes(), createdAt.getUTCSeconds());
    const serverMs = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
    const diff = clientMs - serverMs;
    return (diff >= -TICKET_CREATED_AT_MAX_PAST_MS &&
        diff <= TICKET_CREATED_AT_MAX_FUTURE_MS);
}
